import { render, staticRenderFns } from "./add-object.vue?vue&type=template&id=bc72aec6&scoped=true&"
import script from "./add-object.vue?vue&type=script&lang=js&"
export * from "./add-object.vue?vue&type=script&lang=js&"
import style0 from "./add-object.vue?vue&type=style&index=0&lang=less&"
import style1 from "./add-object.vue?vue&type=style&index=1&id=bc72aec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc72aec6",
  null
  
)

export default component.exports